import { useEffect, useState } from 'react';
import {default as packageInfo} from '../../../package.json';

import { ChatBot } from '../ChatBot';
import { ChatBotOverlay } from '../../components/ChatBotOverlay';
import { useAppSelector } from '../../hooks';

const TheFooter = () => {

  const { showSettingsInfo } = useAppSelector( state => state.webSettings );
  const { jsonVersion } = useAppSelector(state => state.webSettings);

  const [deviceID, setDeviceId] = useState('');
  useEffect(() => {
    if(window.deviceID) setDeviceId(window.deviceID.slice(0,8));
  }, []);

  const getCurrentYear = () => { return new Date().getFullYear();};

  return (
    <>
      <footer className="absolute bottom-6 flex flex-row items-end w-full px-12">
        <p className=" text-white">©{getCurrentYear()} Oriental. Derechos Reservados. | Núm. de Ruta y Tránsito:  221571415 </p>
        <div>
          <p className="text-white opacity-40 pl-8">
            {deviceID} {showSettingsInfo && `  -  JSON:${jsonVersion}  -  WEB:${packageInfo.version}`}
          </p>
        </div>
      </footer>
      <ChatBot />
      <ChatBotOverlay />
    </>

  );
};
export default TheFooter;
